import { formatDate, parseDate } from "../../utils/parsers";

import Card from "react-bootstrap/Card";
import PatientSummary from "./PatientSummary";
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { connect } from "react-redux";

class PatientInfoCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        {this.props.ptId !== this.props.micro_id ? (
          <Spinner animation="border" />
        ) : (
          <Card className="fixed-top-card">
            <Card.Body className="ps-0 pe-0 pb-0 text-dark">
              <PatientSummary micro_id={this.props.micro_id} />
            </Card.Body>
          </Card>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    patient: state.patient.patient,
    ptId: state.patient.micro_id,
  };
}

export default connect(mapStateToProps)(PatientInfoCard);
